module.exports = __webpack_public_path__ + "static/media/bunny.ea78432b.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/bunny.png
// module id = 22
// module chunks = 0